import * as T from '@/types'
import store from '@/store/store'
import EventBus from '@/event-bus'

import config from '@/config'
import resources from '@/api/resources'

import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import caseConverter from 'axios-case-converter'
import _get from 'lodash/get'
import { queryParamsSerializer } from '@/store/utils'

////////////////////////////////////////////////////////////////
// instance
////////////////////////////////////////////////////////////////

// @ts-ignore
const api: T.CreditorDeskApi = axios.create({
        baseURL: `${config.API.URL}`,

        headers: {
            // xApiKey: `${config.API.API_KEY}`,
            // contentType: 'application/json',
            'x-api-key': `${config.API.API_KEY}`,
            'content-type': 'application/json',
        },

        paramsSerializer: queryParamsSerializer,

    })

api.interceptors.response.use(
    (response: AxiosResponse) => {
        return response
    },
    (error: AxiosError) => {
        const { response } = error
        console.log('ERROR RESPONSE', response)
        if (response) {
            const { status } = response

            if (status === 401) {
                if (store.getters['auth/token']){
                    store.dispatch('auth/logout')
                } else {
                    console.log('Not logged in, throwing')
                }
            }

            else if (response.request.responseURL.endsWith('forgot-your-password')) {
                // Fail silently for security purposes...
            }

            else if (response.request.responseURL.includes('file-transfer-settings')
                && response.config.method === 'post'
                && status === 400
                ) {
                // Allow 400 to be handled in view
            }

            else if (status >= 400 && status !== 402 && status !== 403 && status !== 422) {
                const message = _get(response, 'data.data.message') || `An unexpected error has occurred. Please try again or reload the page. (${status})`
                
                EventBus.$emit('app-error', message)
            }
        }

        throw error
    },
)

/**
 * Insert `Authorization` header for every request.
 */
api.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = store.getters['auth/token']
    if (!token) return config

    return {
        ...config,
        headers: {
            ...config.headers,
            authorization: `Bearer ${token}`,
        },
    }
})

// attach resource objects to api prototype
resources(api)

export default api
